var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _notificationTypeToPo;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Children } from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import classNames from 'classnames';
import css from './Notification.scss';
import WixComponent from '../BaseComponents/WixComponent';
import { children, once, optional, any } from '../../src/Composite';
import CloseButton from './CloseButton';
import TextLabel from './TextLabel';
import ActionButton from './ActionButton';

export var LOCAL_NOTIFICATION = 'local';
export var GLOBAL_NOTIFICATION = 'global';
export var STICKY_NOTIFICATION = 'sticky';
export var DEFAULT_TIMEOUT = 6000;

export var notificationTypeToPosition = (_notificationTypeToPo = {}, _defineProperty(_notificationTypeToPo, LOCAL_NOTIFICATION, 'absolute'), _defineProperty(_notificationTypeToPo, GLOBAL_NOTIFICATION, 'relative'), _defineProperty(_notificationTypeToPo, STICKY_NOTIFICATION, 'fixed'), _notificationTypeToPo);

var animationsTimeouts = {
  enter: 500,
  leave: 350
};

function FirstChild(props) {
  var childrenArray = Children.toArray(props.children);
  return childrenArray[0] || null;
}

function mapChildren(children) {
  var childrenArray = Children.toArray(children);

  if (childrenArray.length === 3) {
    return {
      label: childrenArray[0],
      ctaButton: childrenArray[1],
      closeButton: childrenArray[2]
    };
  } else {
    return {
      label: childrenArray[0],
      closeButton: childrenArray[1]
    };
  }
}

var Notification = function (_WixComponent) {
  _inherits(Notification, _WixComponent);

  function Notification(props) {
    _classCallCheck(this, Notification);

    var _this = _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).call(this, props));

    _this.state = {
      hideByCloseClick: false,
      hideByTimer: false
    };

    _this.startCloseTimer(props);
    return _this;
  }

  _createClass(Notification, [{
    key: 'startCloseTimer',
    value: function startCloseTimer(_ref) {
      var _this2 = this;

      var type = _ref.type,
          timeout = _ref.timeout;

      if (type !== GLOBAL_NOTIFICATION) {
        this.closeTimeout = setTimeout(function () {
          _this2.hideNotificationOnTimeout();
        }, timeout || DEFAULT_TIMEOUT);
      }
    }
  }, {
    key: 'clearCloseTimeout',
    value: function clearCloseTimeout() {
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
      }
    }
  }, {
    key: 'hideNotificationOnCloseClick',
    value: function hideNotificationOnCloseClick() {
      var _this3 = this;

      this.setState({ hideByCloseClick: true });
      setTimeout(function () {
        _this3.props.onClose && _this3.props.onClose('hide-by-close-click');
      }, animationsTimeouts.leave + 100);
    }
  }, {
    key: 'hideNotificationOnTimeout',
    value: function hideNotificationOnTimeout() {
      var _this4 = this;

      this.setState({ hideByTimer: true });
      setTimeout(function () {
        _this4.props.onClose && _this4.props.onClose('hide-by-timer');
      }, animationsTimeouts.leave + 100);
    }
  }, {
    key: 'bypassCloseFlags',
    value: function bypassCloseFlags() {
      this.setState({
        hideByCloseClick: false,
        hideByTimer: false
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.show) {
        this.bypassCloseFlags();
        this.clearCloseTimeout();
        this.startCloseTimer(nextProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearCloseTimeout();
    }
  }, {
    key: 'shouldShowNotification',
    value: function shouldShowNotification() {
      return this.props.show && !this.state.hideByCloseClick && !this.state.hideByTimer;
    }
  }, {
    key: 'getWrapperClassNames',
    value: function getWrapperClassNames() {
      var _classNames;

      var _props = this.props,
          type = _props.type,
          theme = _props.theme,
          size = _props.size;


      var position = notificationTypeToPosition[type];

      return classNames((_classNames = {}, _defineProperty(_classNames, css.notificationWrapper, true), _defineProperty(_classNames, css[theme + 'Theme'], true), _defineProperty(_classNames, css[size + 'Size'], true), _defineProperty(_classNames, css[position + 'Position'], true), _classNames));
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel(component) {
      return React.createElement(
        'div',
        { key: 'label', className: css.labelWrapper },
        component
      );
    }
  }, {
    key: 'renderActionButton',
    value: function renderActionButton(component) {
      return component ? React.createElement(
        'div',
        { key: 'cta', className: css.ctaButtonWrapper },
        component
      ) : null;
    }
  }, {
    key: 'renderCloseButton',
    value: function renderCloseButton(component) {
      var _this5 = this;

      return React.createElement(
        'div',
        {
          'data-hook': 'notification-close-button',
          key: 'close',
          className: css.closeButtonWrapper,
          onClick: function onClick() {
            return _this5.hideNotificationOnCloseClick();
          }
        },
        component
      );
    }
  }, {
    key: 'renderNotification',
    value: function renderNotification() {
      var _props2 = this.props,
          zIndex = _props2.zIndex,
          children = _props2.children;


      var childrenComponents = mapChildren(children);

      return React.createElement(
        'div',
        {
          'data-hook': 'notification-wrapper',
          className: this.getWrapperClassNames(),
          style: { zIndex: zIndex }
        },
        React.createElement(
          'div',
          { className: css.contentWrapper },
          this.renderLabel(childrenComponents.label),
          this.renderActionButton(childrenComponents.ctaButton)
        ),
        this.renderCloseButton(childrenComponents.closeButton)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: css.notificationComponent },
        React.createElement(
          ReactCSSTransitionGroup,
          {
            component: FirstChild,
            transitionName: {
              enter: css.notificationAnimationEnter,
              enterActive: css.notificationAnimationEnterActive,
              leave: css.notificationAnimationLeave,
              leaveActive: css.notificationAnimationLeaveActive
            },
            transitionEnterTimeout: animationsTimeouts.enter,
            transitionLeaveTimeout: animationsTimeouts.leave
          },
          this.shouldShowNotification() ? this.renderNotification() : null
        )
      );
    }
  }]);

  return Notification;
}(WixComponent);

Notification.propTypes = {
  show: PropTypes.bool,
  theme: PropTypes.oneOf(['standard', 'error', 'success', 'warning', 'premium']),
  size: PropTypes.oneOf(['small', 'big']),
  type: PropTypes.oneOf([GLOBAL_NOTIFICATION, LOCAL_NOTIFICATION, STICKY_NOTIFICATION]),
  timeout: PropTypes.number,
  zIndex: PropTypes.number,
  onClose: PropTypes.func,
  children: children(once(TextLabel), any(), optional(CloseButton))
};

Notification.defaultProps = {
  theme: 'standard',
  size: 'small',
  type: GLOBAL_NOTIFICATION,
  onClose: null
};

Notification.CloseButton = CloseButton;
Notification.TextLabel = TextLabel;
Notification.ActionButton = ActionButton;

export default Notification;
//# sourceMappingURL=Notification.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Notification/Notification.js